// src/themes/lino/elements/Header/Header.tsx
import Image from 'next/image';
import Link from 'next/link';
import { getMainMenu } from '@/core/lib/api/main/menu-api';
import { getSettings } from '@/core/lib/api/main/setting';
import HeaderContainer from './HeaderContainer';
import HeaderMegaMenuBackdrop from './HeaderMegaMenuBackdrop';
import HeaderNavAction from './HeaderNavAction';
import HeaderNavMenu from './HeaderNavMenu';
import HeaderNavToggle from './HeaderNavToggle';
import Sidebar from './Sidebar';

export default async function Header() {
  try {
    const setting = await getSettings();
    const mainMenu = await getMainMenu();

    if (!setting) {
      return (
        <header className="fixed top-0 inset-x-0 z-50 h-24 bg-primary-50 border-b border-primary-200 flex items-center justify-between px-5 py-4 sm:px-8 lg:px-16">
          <div className="flex items-center gap-5 w-5/12">
            <div className="w-8 h-8 bg-primary-100 rounded-full animate-pulse" />
          </div>
          <div className="flex items-center justify-center h-full w-2/12">
            <div className="w-24 h-6 bg-primary-100 rounded animate-pulse" />
          </div>
          <div className="w-5/12" />
        </header>
      );
    }
    return (
      <>
        <HeaderMegaMenuBackdrop />
        <HeaderContainer>
          <div className="flex items-center gap-3 shrink-0">
            <HeaderNavToggle />
            <Link href="/" className="flex items-center gap-2.5">
              {setting.logo_mobile && (
                <Image
                  src={setting.logo_mobile}
                  alt={setting.site_title || 'Logo'}
                  width={20}
                  height={20}
                  className="object-contain lg:hidden transition-[filter] duration-300 group-data-[transparent=true]:brightness-0 group-data-[transparent=true]:invert"
                />
              )}
              {setting.logo_desktop && (
                <Image
                  src={setting.logo_desktop}
                  alt={setting.site_title || 'Logo'}
                  width={90}
                  height={90}
                  className="object-contain hidden lg:flex transition-[filter] duration-300 group-data-[transparent=true]:brightness-0 group-data-[transparent=true]:invert"
                />
              )}
            </Link>
          </div>
          <div className="flex-1 flex items-center justify-center h-full min-w-0 px-4">
            <HeaderNavMenu />
          </div>
          <HeaderNavAction />
        </HeaderContainer>
        <Sidebar mainItems={mainMenu} />
      </>
    );
  } catch {
    return (
      <header className="fixed top-0 inset-x-0 z-50 h-24 bg-primary-50 border-b border-primary-200 flex items-center justify-between px-5 py-4 sm:px-8 lg:px-16">
        <div className="flex items-center gap-5 w-5/12">
          <div className="w-8 h-8 bg-primary-100 rounded-full animate-pulse" />
        </div>
        <div className="flex items-center justify-center h-full w-2/12">
          <div className="w-24 h-6 bg-primary-100 rounded animate-pulse" />
        </div>
        <div className="w-5/12" />
      </header>
    );
  }
}